import { ServiceMaker } from ".";
import { buildQueryString } from './index';

export const listJobPost = (data:any) =>
ServiceMaker(`career/listJobPost?${buildQueryString(data)}`, "GET");